export default "__VITE_ASSET__DaQVLw7K__"